import {getKeyMap} from '@/api/user.js'
import {fillerLeft} from '@/utils/index.js'

export function setKeyMap(obj,keys = []) {

    if(keys.length == 0 && Object.keys(obj).length != 0){
        getKeyMap(Object.keys(obj)).then(r =>{
            fillerLeft(obj,r)
        }).catch(_=>{})
    }else {
        return getKeyMap(keys)
    }
}